import { useMemo } from 'react'
import { Task } from '../../../types'

interface UseLyricsEnabledProps {
  task: Task
  force?: boolean
}

export function useLyricsEnabled({
  task,
  force = false
}: UseLyricsEnabledProps): boolean {
  const { separate: separateOperation, lyrics: lyricsOperation } =
    task.summary.v1

  const hasSeparateAvailable = useMemo(
    () => !!separateOperation && separateOperation?.status === 'COMPLETED',
    [separateOperation]
  )

  const hasLyricsAvailable = useMemo(
    () => !!lyricsOperation && lyricsOperation?.status === 'COMPLETED',
    [lyricsOperation]
  )

  const hasVocals = separateOperation?.stems?.some((i) => i?.stem === 'vocals')

  return useMemo(() => {
    if (!hasSeparateAvailable) {
      return force
    }

    const hasVocalsAvailable =
      (!!separateOperation &&
        separateOperation?.status === 'COMPLETED' &&
        hasVocals) ||
      (!!lyricsOperation && lyricsOperation?.status === 'COMPLETED')

    if ((!hasVocalsAvailable && !hasLyricsAvailable) || !task?.isDemo) {
      return force
    }

    return !!hasLyricsAvailable
  }, [
    force,
    hasLyricsAvailable,
    hasSeparateAvailable,
    hasVocals,
    lyricsOperation,
    separateOperation,
    task?.isDemo
  ])
}
